import { Box, Typography } from '@mui/material';
import { AppStoreButtons } from './AppStoreButtons';

export const HeroHeader = () => {
  return (
    <Box
      sx={{
        textAlign: 'center',
        mb: { xs: 6, md: 8 },
      }}
    >
      <Typography
        variant="h1"
        sx={{
          mb: 3,
          fontWeight: 800,
        }}
      >
        Smart Nutrition Assistant
        <br />
        Powered by AI
      </Typography>

      <Typography
        variant="body1"
        color="text.secondary"
        sx={{
          mb: 5,
          maxWidth: '600px',
          mx: 'auto',
        }}
      >
        Combine artificial intelligence for food recognition with personalized
        meal planning and hydration tracking. No complicated dietary systems
        or manual logging procedures.
      </Typography>

      <AppStoreButtons />
    </Box>
  );
};
